export function createBasicProps (env, name) {
  let obj = {
    key       : name, 
    className : name,
    style     : (env.styleObj[name])? Object.assign({}, env.styleObj[name]) : {}
  };
  return obj;
}

export function camelCaseTransformerFn (orinal_name) {
  let newName = '';
  newName = orinal_name.replace(/-(\w)/g, 
    function(all, letter) {
      return letter.toUpperCase();
    }
  );
  return newName;
}
